<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    [hasDetailView]="true">
</acabim-datatable>

<p-footer class="cas-action-buttons">
    <button type='button' class="cas-button-action" (click)="onAddProjectGroup()">Add project group</button>
</p-footer>
    <acabim-modal
            [display]="addProjectGroupModal"
            [title]="'Add project group details'"
            (status)="setAddProjectGroupModal($event)"
            [footer]="false"
            width="70vw"
    >
        <acabim-admin-groups-project-add
                actionType="add"
                actionButtonLabel="Add"
                (completed)="onAddCompletion($event)">
        </acabim-admin-groups-project-add>
    </acabim-modal>

<ng-template [ngIf]="dataSources[0].showDetails">
    <acabim-modal
            [display]="true"
            [title]="'Edit project group details'"
            (status)="setEditProjectGroupModal($event)"
            [footer]="false"
            width="70vw"
    >
        <acabim-admin-groups-project-update
                [projectDetails]="dataSources[0].detailData"
                (completed)="onEditCompletion($event)">
        </acabim-admin-groups-project-update>
    </acabim-modal>
</ng-template>
